import { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteButton from '../../../../../../common/components/DeleteButton/DeleteButton';
import Button from '@mui/material/Button';
import ActionGroup from '../../../../../../common/components/ActionGroup';
import {hetch} from "../../../../../../utils/fetch.hooked";

function ActionButtons({ openEditModal, id, triggerRefetch }) {
  const [isFetching, setIsFetching] = useState(false);

  const removeItem = () => {
    setIsFetching(true);
    hetch(`/api/administrators/${id}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'DELETE',
      body: null
    })
      .then(() => triggerRefetch())
      .finally(() => setIsFetching(false));
  }

  return (
    <ActionGroup align="right">
      <Button
        title="Редактировать пользователя"
        variant="contained"
        color="primary"
        disabled={isFetching}
        onClick={openEditModal}
      >
        <EditIcon />
      </Button>
      <DeleteButton
        title="Удалить пользователя"
        message="Вы действительно хотите удалить пользователя?"
        isFetching={isFetching}
        onConfirm={removeItem}
      />
    </ActionGroup>
  );
}

export default ActionButtons;
